module.exports = __webpack_public_path__ + "static/57import-91a9b7b19af55de08485d9cab1972d40.png";